export default {
  example: '한국어',
  example2: '난괜찮아',
}
